import React, { useEffect, useState } from 'react';

//SERVICES/API
import { procurementApi } from '@/main/api';
import { OrderStatusEnum } from '@/main/services/enum/OrderStatusEnum';

//TYPES
import {
  GetItemsByStatusRequest,
  ChangeStatusItemsRequest as ChangeStatusItemsRequest,
  ProcurementSupplierItemsRequest
} from '@/main/models/request';
import { GetItemsByStatusResponse } from '@/main/models/response';
import { IInfoSideComponent } from '../infoOrder/typesInfoOrder';

//SCREENS/COMPONENTS/STYLES LOCAL
import ReceivedToInvoiced from './sections/receivedToInvoiced​/receivedToInvoiced​';
import ChangeStatus from './sections/changeStatus/changeStatus';
import { getTranslateByKey } from '@/main/services/utils';
import AssignedToInTransit from './sections/AssignedToInTransit/assignedToInTransit';

interface IChangeOrderStatusModal {
  infoSideComponent: IInfoSideComponent;
  setInfoSideComponent: React.Dispatch<
    React.SetStateAction<IInfoSideComponent>
  >;
  handleUpdateQuoteCountStatus: () => void;
  handleUpdateQuoteGridStatus: (
    guid: string,
    newStatus: number,
    newStatusSupplierName: string
  ) => void;
  INITIAL_INFO_SIDE: IInfoSideComponent;
  loadViewOrder: (guidQuoteProcurement: string | undefined) => Promise<void>;
}

function ChangeOrderStatusModal({
  infoSideComponent,
  setInfoSideComponent,
  handleUpdateQuoteCountStatus,
  handleUpdateQuoteGridStatus,
  INITIAL_INFO_SIDE,
  loadViewOrder
}: IChangeOrderStatusModal) {
  const [options, setOptions] = useState<GetItemsByStatusResponse[]>([]);
  const [optionsSelected, setOptionsSelected] = useState<string[]>([]);
  const [loadingOptions, setLoadingOptions] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>([]);

  function handleCloseModal() {
    setInfoSideComponent(INITIAL_INFO_SIDE);
  }

  useEffect(() => {
    if (!INITIAL_INFO_SIDE.open) {
      setFiles([]);
    }
  }, [INITIAL_INFO_SIDE]);


  async function changeStatusApi(request: ChangeStatusItemsRequest) {
    try {
      setLoadingSubmit(true);
      const responseApi = await procurementApi.changeStatusItems(request, files);

      if (responseApi.data.result) {
        const resData = responseApi.data.result;
        if (
          resData.orderNewStatusIdChanged &&
          infoSideComponent.statusSupplier
        ) {
          handleUpdateQuoteCountStatus();
          handleUpdateQuoteGridStatus(
            infoSideComponent.guidQuoteProcurement || '',
            resData.orderNewStatusIdChanged,
            resData.orderNewStatusNameChanged
          );
        }
      }

      loadViewOrder(infoSideComponent.guidQuoteProcurement || '');
      setInfoSideComponent(INITIAL_INFO_SIDE);
      setOptions([]);
      setOptionsSelected([]);
    } catch (error) {
    } finally {
      setLoadingSubmit(false);
    }
  }

  function handleSubmitChangeStatus(extraData?: Pick<ChangeStatusItemsRequest, 'shippingName' | 'trackingCode'>) {
    let procurementSupplierItems: ProcurementSupplierItemsRequest[] = [];
    optionsSelected.map(selected => {
      options.map(option => {
        if (option.guidProcurementSupplierItem === selected) {
          return procurementSupplierItems.push({
            guidProcurementSupplierItem: option.guidProcurementSupplierItem,
            idProcurementStatusCompany: option.idProcurementStatusCompany
          });
        }
      });
    });

    if (infoSideComponent.guidQuoteProcurement) {
      const request: ChangeStatusItemsRequest = {
        guidProcurement: infoSideComponent.guidQuoteProcurement || '',
        guidProcurementSupplier:
          infoSideComponent.guidProcurementSupplier || '',
        idProcurementStatusCompanyNext:
          infoSideComponent.idProcurementStatusCompany || null,
        procurementSupplierItems,
        ...extraData
      };

      changeStatusApi(request);
    }
  }

  useEffect(() => {
    if (
      infoSideComponent.guidProcurementStatusCompany &&
      infoSideComponent.guidProcurementSupplier
    ) {
      const resquest: GetItemsByStatusRequest = {
        guidProcurementStatusCompany: infoSideComponent.guidProcurementStatusCompany,
        guidProcurementSupplier: infoSideComponent.guidProcurementSupplier,
        deliveryBySupplier: infoSideComponent.deliveryBySupplier,
      };
      setLoadingOptions(true);
      procurementApi
        .getItemsByStatus(resquest)
        .then(res => {
          const dataRes = res.data.result;
          dataRes.map(option => {
            setOptionsSelected(prev => [
              ...prev,
              option.guidProcurementSupplierItem
            ]);
          });
          setOptions(dataRes);
        })
        .catch(() => { })
        .finally(() => setLoadingOptions(false));
    }
  }, [
    infoSideComponent.guidProcurementStatusCompany,
    infoSideComponent.guidProcurementSupplier
  ]);

  useEffect(() => {
    if (infoSideComponent.open == false) {
      setOptions([]);
      setOptionsSelected([]);
    }
  }, [infoSideComponent.open]);

  function renderModal() {
    switch (infoSideComponent.statusSupplier) {
      case OrderStatusEnum.Transit:
        return (
          <AssignedToInTransit
            closeModal={handleCloseModal}
            options={options}
            optionsSelected={optionsSelected}
            setOptionsSelected={setOptionsSelected}
            files={files}
            setFiles={setFiles}
            handleSubmitChangeStatus={handleSubmitChangeStatus}
            loadingSubmit={loadingSubmit}
            loadingOptions={loadingOptions}
          />
        );

      case OrderStatusEnum.Delivered:
        return (
          <ChangeStatus
            confirmMessage={getTranslateByKey('information.deliver')}
            closeModal={handleCloseModal}
            options={options}
            optionsSelected={optionsSelected}
            setOptionsSelected={setOptionsSelected}
            files={files}
            setFiles={setFiles}
            handleSubmitChangeStatus={handleSubmitChangeStatus}
            loadingSubmit={loadingSubmit}
            loadingOptions={loadingOptions}
          />
        );

      case OrderStatusEnum.Received:
        return (
          <ChangeStatus
            confirmMessage={getTranslateByKey('information.receive')}
            closeModal={handleCloseModal}
            options={options}
            optionsSelected={optionsSelected}
            setOptionsSelected={setOptionsSelected}
            files={files}
            setFiles={setFiles}
            handleSubmitChangeStatus={handleSubmitChangeStatus}
            loadingSubmit={loadingSubmit}
            loadingOptions={loadingOptions}
          />
        );

      case OrderStatusEnum.Invoiced:
        return (
          <ReceivedToInvoiced
            closeModal={handleCloseModal}
            options={options}
            optionsSelected={optionsSelected}
            setOptionsSelected={setOptionsSelected}
            infoSideComponent={infoSideComponent}
            loadViewOrder={loadViewOrder}
            handleSubmitChangeStatus={handleSubmitChangeStatus}
            loadingOptions={loadingOptions}
          />
        );

      case OrderStatusEnum.Paid:
        return (
          <ChangeStatus
            confirmMessage={getTranslateByKey('information.pay')}
            closeModal={handleCloseModal}
            options={options}
            optionsSelected={optionsSelected}
            setOptionsSelected={setOptionsSelected}
            files={files}
            setFiles={setFiles}
            handleSubmitChangeStatus={handleSubmitChangeStatus}
            loadingSubmit={loadingSubmit}
            loadingOptions={loadingOptions}
          />
        );

      default:
        break;
    }
  }

  return <>{renderModal()}</>;
}

export default ChangeOrderStatusModal;
